import { render, staticRenderFns } from "./NodeIndication.vue?vue&type=template&id=81efa8f6"
import script from "./NodeIndication.vue?vue&type=script&lang=js"
export * from "./NodeIndication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports